import { BigNumber, ethers } from "ethers";
import ABI from "../contracts/DepositAndSwapV3LidoRP.json";
import { useState, useEffect } from "react";
import { useMoralis, useChain } from "react-moralis";
import ERC20Abi from "../contracts/ERC20.json";
import "../App.css";
import lidoLogo from "../lido-logo.png";
import rPLogo from "../rp-logo.png";
import { swapContractAddress, NFTDAddress } from "../constants";

const MintStable = () => {
  const [currency, setCurrency] = useState("");
  const [value, setValue] = useState("");
  const [NFTDBalance, setNFTDBalance] = useState(0);
  const [RETHBalance, setRETHBalance] = useState(0);
  const [STETHBalance, setSTETHBalance] = useState(0);
  const [decimals, setDecimals] = useState(0);
  const [disabledSwapButton, setDisabledSwapButton] = useState(true);
  const [hiddenNotification, setHiddenNotification] = useState(true);
  const [message, setMessage] = useState("");
  const [pool, setPool] = useState("");
  const { web3, account, isWeb3Enabled } = useMoralis();
  const { chainId } = useChain();

  useEffect(() => {
    if (isWeb3Enabled && chainId === "0x5") {
      fetchNFTDBalance();
      fetchRETHBalance();
      fetchSTETHBalance();
    }
  }, [isWeb3Enabled, web3, pool]);

  useEffect(() => {
    if (isWeb3Enabled && chainId === "0x5" && currency !== "") {
      getDecimals();
    }
  }, [currency, isWeb3Enabled, web3]);

  const displayNotification = (displayedMessage) => {
    setMessage(displayedMessage);
    setHiddenNotification(false);
  };
  const fetchNFTDBalance = async () => {
    let signer = web3.getSigner();
    const NFTDContract = new ethers.Contract(NFTDAddress, ERC20Abi, signer);

    setNFTDBalance(BigNumber.from(await NFTDContract.balanceOf(account)));
  };

  const fetchRETHBalance = async () => {
    let signer = web3.getSigner();

    const swapContract = new ethers.Contract(swapContractAddress, ABI, signer);

    let RETHbalanceTemp = String(
      await swapContract.depositedRethByUser(account)
    );
    let RETHBalanceFormatted = Number(
      ethers.utils.formatEther(RETHbalanceTemp)
    ).toFixed(4);
    setRETHBalance(RETHBalanceFormatted);
  };

  const fetchSTETHBalance = async () => {
    let signer = web3.getSigner();

    const swapContract = new ethers.Contract(swapContractAddress, ABI, signer);

    let STETHbalanceTemp = String(
      await swapContract.depositedLidoByUser(account)
    );
    let STETHBalanceFormatted = Number(
      ethers.utils.formatEther(STETHbalanceTemp)
    ).toFixed(4);
    setSTETHBalance(STETHBalanceFormatted);
  };
  const selectCurrency = (e) => {
    setCurrency(e.target.value);
  };

  const valueInput = async (e) => {
    setValue(e.target.value);
  };

  const approve = async () => {
    let signer = web3.getSigner();
    const selectedStablecoin = new ethers.Contract(currency, ERC20Abi, signer);
    let tx = await selectedStablecoin.approve(
      swapContractAddress,
      ethers.utils.parseUnits(value, decimals)
    );
    displayNotification("Approve pending ... ");
    setHiddenNotification(false);
    let response = await tx.wait();
    if (response) {
      displayNotification("Approve Successful.");
      setDisabledSwapButton(false);
    } else {
      displayNotification("Error with the approve transaction");
    }
  };

  const getDecimals = async () => {
    let signer = web3.getSigner();
    const selectedStablecoin = new ethers.Contract(currency, ERC20Abi, signer);
    let decimals = Number(await selectedStablecoin.decimals());
    setDecimals(decimals);
  };

  return (
    <div className="mintStableBody">
      <h4 className="explanation">
        NFTD is a fully decentralised stablecoin with 100% capital efficiency,
        backed by staked ETH, generating staking yield for the stablecoin
        holder.
      </h4>
      <a
        className="btn btn-light"
        href="https://goerlifaucet.com/"
        target="blank"
      >
        Get Goerli Ether
      </a>{" "}
      <a
        href="https://app.uniswap.org/chain=gorli#/swap?exactField=input&inputCurrency=ETH&outputCurrency=0x11fE4B6AE13d2a6055C8D9cF65c55bac32B5d844"
        target="blank"
        className="btn btn-light"
      >
        {" "}
        Buy test DAI
      </a>
      <a
        href="https://app.uniswap.org/chain=gorli#/swap?exactField=input&inputCurrency=ETH&outputCurrency=0x07865c6E87B9F70255377e024ace6630C1Eaa37F"
        target="blank"
        className="btn btn-light"
      >
        Buy Test USDC
      </a>
      <h2 style={{ margin: "1rem" }}>Choose a staking pool:</h2>
      <div className="poolSelectorWrapper">
        <div
          className="card"
          style={{
            width: "18rem",
            margin: "4rem",
            marginTop: 0,
            backgroundColor: "lightgray",
            marginBottom: 0,
            border: pool === "lido" ? "2px solid black" : "none",
          }}
          onClick={() => {
            setPool("lido");
          }}
        >
          <img src={lidoLogo} className="card-img-top" alt="Lido" />
          <div className="card-body">
            <h5 className="card-title">Lido</h5>
            <p className="card-text">APR 6.5% </p>
            <p className="card-text"> Minimum deposit: 0.02 ETH</p>
          </div>
        </div>
        <div
          className="card"
          style={{
            width: "18rem",
            margin: "4rem",
            marginTop: 0,
            marginBottom: 0,
            backgroundColor: "lightgray",
            border: pool === "rp" ? "2px solid black" : "none",
          }}
          onClick={() => {
            setPool("rp");
          }}
        >
          <img
            src={rPLogo}
            style={{ marginTop: "3em", marginBottom: "2.5em" }}
            className="card-img-top"
            alt="rocketPool"
          />
          <div className="card-body">
            <h5 className="card-title">Rocket Pool</h5>
            <p className="card-text">APR 7.6%</p>
            <p className="card-text"> Minimum deposit: 0.02 ETH</p>
          </div>
        </div>
      </div>
      <h3> Mint NFTD with a stablecoin of your choice:</h3>
      <div className="stablecoinInput">
        <label htmlFor="amount"></label>
        {
          <select
            id="stablecoinList"
            onChange={(e) => {
              selectCurrency(e);
            }}
          >
            <option className="dropdown-toggle">Select stablecoin:</option>
            <option value="0x11fE4B6AE13d2a6055C8D9cF65c55bac32B5d844">
              DAI
            </option>
            <option value="0x07865c6E87B9F70255377e024ace6630C1Eaa37F">
              USDC
            </option>
          </select>
        }

        <input
          type="number"
          placeholder="Enter amount"
          value={value}
          onChange={(e) => {
            valueInput(e);
          }}
        ></input>
        <button
          className="btn btn-secondary"
          onClick={() => {
            approve();
          }}
          disabled={!currency || !value || !pool}
        >
          Approve
        </button>
        <button
          className="btn btn-info swap"
          onClick={async () => {
            let signer = web3.getSigner();
            const swapContract = new ethers.Contract(
              swapContractAddress,
              ABI,
              signer
            );
            let tx =
              pool === "lido"
                ? await swapContract.swapLI(
                    ethers.utils.parseUnits(value, decimals),
                    currency,
                    decimals
                  )
                : await swapContract.swapRP(
                    ethers.utils.parseUnits(value, decimals),
                    currency,
                    decimals
                  );
            displayNotification("Swap pending ... ");

            await tx.wait().then((response) => {
              response
                ? displayNotification("Swap successful")
                : displayNotification("error with the swap transaction");
            });
          }}
          disabled={disabledSwapButton}
        >
          Swap
        </button>
        <label>NFTD Received </label>
        <input
          type="number"
          placeholder="NFTD Received"
          disabled={true}
          value={value}
        ></input>
      </div>
      <div id="infoCluster">
        <p>
          NFTD balance of user:{" "}
          <span>{ethers.utils.formatEther(NFTDBalance)}</span>{" "}
        </p>
        <p>
          {" "}
          total rETH staked by user on RocketPool:{" "}
          <span>{RETHBalance} rETH</span>
        </p>
        <p>
          {" "}
          total stETH staked by user on Lido : <span>{STETHBalance} stETH</span>
        </p>
      </div>
      <div
        className="alert alert-warning notification"
        role="alert"
        hidden={hiddenNotification}
      >
        <button
          className="btn btn-light"
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "1.6em",
            height: "1.6em",
          }}
          onClick={() => setHiddenNotification(true)}
        >
          X
        </button>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default MintStable;
